// react-table's default comparator reverses tied rows in descending order.
// Preserve source/ranking order for ties in either direction.
export const stableOrderBy = (rows, comparators, directions) => [...rows].sort((a, b) => {
  for (let i = 0; i < comparators.length; i += 1) {
    const result = comparators[i](a, b);
    if (result !== 0) return directions[i] === false || directions[i] === 'desc' ? -result : result;
  }
  return a.index - b.index;
});
